<script setup lang="ts">
//#region imports
import { computed, useSlots } from 'vue';
//#endregion

export interface Props {
  title?: string,
  tooltip?: string,
}
//#region define
const props = withDefaults(defineProps<Props>(), {
  title: '',
  tooltip: '',
});
//#endregion

//#region composables
const slots = useSlots();
//#endregion

//#region computed
const hasTitle = computed(() => props.title || slots.title);
//#endregion
</script>

<template>
  <div class="card-title">
    <div class="card-title__content">
      <div
        v-if="hasTitle"
        class="card-title__item"
      >
        <div class="card-title__title">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <UiTooltip
          v-if="tooltip"
          :tooltip="tooltip"
        >
          <UiIcon
            name="question-circle"
            class="t:ml-4 t:cursor-pointer"
            color="var(--text-body-tertiary)"
            :size="14"
            substyle="fa-solid"
          />
        </UiTooltip>
      </div>
      <div class="card-title__item">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.card-title{
  &__content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    border-radius: 4px;
    background: var(--background-surface);
    height: 34px;
  }
  &__item {
    display: flex;
    align-items: center;
  }
  &__title{
    color: var(--text-body);
    font-size: 14px;
    font-weight: 500;
  }
}
</style>

